import Breadcrumb from '../components/Breadcrumb';
import { useParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';
import ViewPedidosLayer from '../components/ViewPedidosLayer';

function Edit({ id }) {
    const { data, mutate } = useFetch(`pedido/${id}`);
    return <ViewPedidosLayer data={data} mutate={mutate} backTo="/pedidos" />;
}

function Layer() {
    const { id } = useParams();

    if (id) return <Edit id={id} />;

    return <ViewPedidosLayer backTo="/pedidos" />;
}

const PedidosPage = () => {
    const { id } = useParams();

    return (
        <>
            <Breadcrumb
                title={!Boolean(id) ? 'Lancar - Pedido' : 'Editar - Pedido'}
                icon={!Boolean(id) ? 'solar:cart-plus-outline' : 'solar:clipboard-list-outline'}
            />
            <Layer />
        </>
    );
};

export default PedidosPage;
